import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Loader } from 'components/Loader';
import { useGetOrganizationUsersQuery } from 'data/__generated__';

import { EmbeddedUsersTable } from 'pages/Users/components/EmbeddedUsersTable';
import { isWebAppUser } from 'pages/Users/constants/embeddedUsersColumns';

type ParamTypes = {
    organizationId: string;
};

export const UsersDetails = () => {
    const { organizationId = '' } = useParams<ParamTypes>();

    const { loading, error, data } = useGetOrganizationUsersQuery({
        variables: { organizationId },
    });

    if (loading) {
        return (
            <div className="flex min-h-[200px] w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (error || !data) {
        throw new Error('Une erreur est survenue lors de la récupération des utilisateurs');
    }

    const users = data.organizationUsers;
    const webAppUsers = users.filter(isWebAppUser);
    const employees = users.filter((user) => !isWebAppUser(user));

    return (
        <Columns>
            <Column>
                <ColumnTitle>Comptes web app ({webAppUsers.length})</ColumnTitle>
                <ColumnSubtitle>Administrateurs, éditeurs et analystes</ColumnSubtitle>
                <EmbeddedUsersTable users={webAppUsers} emptyMessage="Aucun compte web app" />
            </Column>
            <Column>
                <ColumnTitle>Employés ({employees.length})</ColumnTitle>
                <ColumnSubtitle>Utilisateurs non admin / éditeur / analyste</ColumnSubtitle>
                <EmbeddedUsersTable users={employees} emptyMessage="Aucun employé" />
            </Column>
        </Columns>
    );
};

const Columns = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
`;

const Column = styled.div`
    display: flex;
    flex: 1;
    min-width: 420px;
    flex-direction: column;
`;

const ColumnTitle = styled.h3`
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.textColor};
`;

const ColumnSubtitle = styled.span`
    margin-top: 2px;
    font-size: 13px;
    color: ${({ theme }) => theme.infoTextColor};
`;
